<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <!-- <router-link :to="'/showfirst/'+licenseApplyId"> -->
					<router-link to="">
                        <i class="el-icon-arrow-left" style="cursor: pointer;" @click="$router.go(-1)"></i>
                        牌照审核详情
                    </router-link>/ 牌照审核详情修改
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-form
                class="addlicense-box"
                ref="addlicenseform"
                :model="addlicenseform"
                :rules="addlicenserules"
            >
                <div class="addlicense-item">
                    <el-form-item label="省份" prop="equipmentCode">
                        <el-input v-model="addlicenseform.provinceName" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="市区" prop="equipmentCode">
                        <el-input v-model="addlicenseform.cityName" :disabled="true"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="车主" prop="equipmentCode">
                        <el-input v-model="addlicenseform.ownerName"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="ownerCellphoneNumber">
                        <el-input v-model="addlicenseform.ownerCellphoneNumber"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="身份证号" prop="ownerIdentityCards">
                        <el-input v-model="addlicenseform.ownerIdentityCards"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="添加照片" prop="ownerCredentialsPhoto">
                        <el-upload
                            class="avatar-uploader avatar-box"
                            action="#"
                            :show-file-list="false"
                            :http-request="uploadAvatarUp"
                            :before-upload="beforeAvatarUpload"
                        >
                            <img
                                v-if="addlicenseform.ownerIdentityCardsPhoto[0]"
                                :src="'/api/static'+addlicenseform.ownerIdentityCardsPhoto[0]"
                                class="avatar"
                            />
                            <i v-else class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="添加照片" prop="ownerCredentialsPhoto">
                        <el-upload
                            class="avatar-uploader avatar-box"
                            action="#"
                            :show-file-list="false"
                            :http-request="uploadAvatarDown"
                            :before-upload="beforeAvatarUpload"
                        >
                            <img
                                v-if="addlicenseform.ownerIdentityCardsPhoto[1]"
                                :src="'/api/static'+addlicenseform.ownerIdentityCardsPhoto[1]"
                                class="avatar"
                            />
                            <i v-else class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </div>

                <div class="addlicense-item">
                    <el-form-item label="设备编码" prop="equipmentCode">
                        <el-input v-model="addlicenseform.equipmentCode"></el-input>
                    </el-form-item>
                    <el-form-item label="整机架号" prop="frameNo">
                        <el-input v-model="addlicenseform.frameNo"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="环保编号" prop="environmentalProtectionNumber">
                        <el-input v-model="addlicenseform.environmentalProtectionNumber"></el-input>
                    </el-form-item>
                    <el-form-item label="燃油类型" prop="fuelType">
                        <el-input v-model="addlicenseform.fuelType"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="排放登记" prop="emissionRegistration">
                        <el-input v-model="addlicenseform.emissionRegistration"></el-input>
                    </el-form-item>
                    <el-form-item label="发动机号" prop="engineNumber">
                        <el-input v-model="addlicenseform.engineNumber"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="发动机功率" prop="enginePower">
                        <el-input v-model="addlicenseform.enginePower"></el-input>
                    </el-form-item>
                    <el-form-item label="整机质量" prop="overallQuality">
                        <el-input v-model="addlicenseform.overallQuality"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="机械品牌" prop="machineryBrand">
                        <el-input v-model="addlicenseform.machineryBrand"></el-input>
                    </el-form-item>
                    <el-form-item label="出厂日期" prop="productionDateStr">
                        <el-date-picker
                            v-model="addlicenseform.productionDateStr"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="出厂日期"
                        ></el-date-picker>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="机械颜色" prop="machineryColor">
                        <el-input v-model="addlicenseform.machineryColor"></el-input>
                    </el-form-item>
                    <el-form-item label="核载信息" prop="nuclearInformation">
                        <el-input v-model="addlicenseform.nuclearInformation"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="机械类型" prop="machineryType">
                        <el-input v-model="addlicenseform.machineryType"></el-input>
                    </el-form-item>
                    <el-form-item label="生产国" prop="productionCountry">
                        <el-input v-model="addlicenseform.productionCountry"></el-input>
                    </el-form-item>
                </div>
                <div class="addlicense-item">
                    <el-form-item label="生产厂家" prop="factory">
                        <el-input v-model="addlicenseform.factory"></el-input>
                    </el-form-item>
                </div>

                <!-- <el-form-item label="添加照片" prop="mechanicalPictures" style="width: 800px;">
					   <el-upload
						 action="#"
						 list-type="picture-card"
						 :on-preview="handlePictureCardPreview"
						 :on-remove="handleRemove"
						 :http-request="uploadAvatar"
						 :before-upload="beforeAvatarUpload"
						 :file-list="fileList"
					   >
						 <i class="el-icon-plus"></i>
					   </el-upload>
					   <el-dialog :visible.sync="dialogVisible">
						 <img width="100%" :src="dialogImageUrl" alt="">
					   </el-dialog>
                </el-form-item>-->

                <!-- <el-button
						type="primary"
						class="handle-del mr10"
						@click = 'uploadbtn()'
                >提交</el-button>-->
                <div class="addlicense-item">
                    <el-form-item label="机械图片" prop="ownerCredentialsPhoto">
                        <el-upload
                            class="avatar-uploader avatar-box"
                            action="#"
                            :show-file-list="false"
                            :http-request="uploadAvatarBottom"
                            :before-upload="beforeAvatarUpload"
                        >
                            <img
                                v-if="addlicenseform.mechanicalPictures"
                                :src="'/api/static'+addlicenseform.mechanicalPictures"
                                class="avatar"
                            />
                            <i v-else class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </div>
                <span>
                    <el-button type="primary" @click="saveAddlicense('addlicenseform')">确 定</el-button>
                    <el-button @click="cancelAddlicense('addlicenseform')">取 消</el-button>
                </span>
            </el-form>
        </div>
    </div>
</template>

<script>
	import {updatePcLicenseApplySh,getLicenseApply} from '@/api/index';
    export default {
        name: 'fz_alterlicense',
        data() {
					 			var validPhone2 = (rule, value, callback) => {
						  // debugger
			       const phoneReg = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
			       if (!value) {
			         //return callback(new Error('电话号码不能为空'))
					 return callback()
			       }else if(!Number.isInteger(+value)) {
			           callback(new Error('请输入数字值'))
			       } else {
			           if (phoneReg.test(value)) {
			             callback()
			        } else {
			             callback(new Error('电话号码格式不正确'))
			           }
			         }
			};
            return {
			addlicenseform:{
				ownerName:'',//车主
				ownerCellphoneNumber:'',//手机号
				applicantName:'',//办理业务员
				provinceName:'',//省份
				cityName:'',//市
				ownerIdentityCards:'',//身份证号
				ownerIdentityCardsPhoto:'',//身份证图片
				mechanicalPictures:'',//机械图片
			 	equipmentCode:'',
				frameNo:'',
				environmentalProtectionNumber:'',
				fuelType:'',
				emissionRegistration:'',
				engineNumber:'',
				enginePower:'',
				overallQuality:'',
				machineryBrand:'',
				productionDateStr:'',
				machineryColor:'',
				nuclearInformation:'',
				machineryType:'',
				productionCountry:'',
				factory:'',
				// mechanicalPictures:''
			 },    //添加机构分支表单
			 addlicenserules: {
			 	  equipmentCode: [
			 		{ required: true, message: '请输入设备编号', trigger: 'blur' }
				   ],
				  ownerName: [
				 	{ required: true, message: '请输入姓名', trigger:['blur', 'change'] }
				 ],
                   ownerCellphoneNumber: [
				 	{ required: true, trigger: ['blur', 'change'], validator: validPhone2 }
				 ],
				 	 ownerIdentityCards: [
				 	{ required: true, trigger: ['blur', 'change'],message: '请输入身份证号'}
				 ],
			 },  //添加表单验证
	
				
				
             dialogImageUrl: '',
			 dialogVisible: false,
			 picList: [],
			 fileList: [],
			 imgArr:[]
				
               
            }
		},
		
		created() {
			this.licenseApplyId = this.$route.params.licenseApplyId;
			// 查看  
			this.getLicenseApplylist();
		},
        methods: {
			getLicenseApplylist(){
				getLicenseApply({
					"licenseApplyId": this.licenseApplyId
				}).then(res => {
					console.log(res.data)
					this.addlicenseform = res.data;
					console.log(res.data.ownerIdentityCardsPhoto)
					 if (res.data.ownerIdentityCardsPhoto) {
						 console.log('111')
						//  console.log(res.data.ownerIdentityCardsPhoto)
						  this.addlicenseform.ownerIdentityCardsPhoto = res.data.ownerIdentityCardsPhoto.split(",")
						  console.log(this.addlicenseform.ownerIdentityCardsPhoto)
						//  if(this.addlicenseform.ownerIdentityCardsPhoto.length == 1){
						// 	  console.log('2222',this.addlicenseform.ownerIdentityCardsPhoto)
						// 	this.addlicenseform.ownerIdentityCardsPhoto =  this.addlicenseform.ownerIdentityCardsPhoto.push('')
						//   console.log('33333',this.addlicenseform.ownerIdentityCardsPhoto)
						// }
					 }else {
						 console.log('33333')
				        this.addlicenseform.ownerIdentityCardsPhoto = ['','']
					 }
					console.log(this.addlicenseform.ownerIdentityCardsPhoto)
					// this.mechanicsId = res.data.mechanicsId;
					// console.log(this.mechanicsId)
				});
			},
			
			uploadAvatarUp(item) {
				var picobj = {};
				const _file = item.file;
				console.log(_file)
				picobj.uid = item.file.uid;
				var formData = new FormData();
				formData.append("file", _file);
				this.$http({
					method:'post',
					headers: { 'Content-Type': 'multipart/form-data' },
					url:"/api/homepage/uploadImages",
					data:formData,
					crossDomain:true,
					cache:false
				}).then(res => {
					// picobj.url = res.data.data[0];
					console.log(res.data.data[0])
					this.addlicenseform.ownerIdentityCardsPhoto.splice(0,1,res.data.data[0])
				  // this.emptyUpload()
				}).catch(() => {
				  this.$message.error('上传失败，请重新上传')
				  // this.emptyUpload()
				})
				
			},
				uploadAvatarDown(item) {
				var picobj = {};
				const _file = item.file;
				console.log(_file)
				picobj.uid = item.file.uid;
				var formData = new FormData();
				formData.append("file", _file);
				this.$http({
					method:'post',
					headers: { 'Content-Type': 'multipart/form-data' },
					url:"/api/homepage/uploadImages",
					data:formData,
					crossDomain:true,
					cache:false
				}).then(res => {
					this.addlicenseform.ownerIdentityCardsPhoto.splice(1,1,res.data.data[0])
				  // this.emptyUpload()
				}).catch(() => {
				  this.$message.error('上传失败，请重新上传')
				  // this.emptyUpload()
				})
				
			},
			uploadAvatarBottom(item) {
				var picobj = {};
				const _file = item.file;
				console.log(_file)
				picobj.uid = item.file.uid;
				var formData = new FormData();
				formData.append("file", _file);
				this.$http({
					method:'post',
					headers: { 'Content-Type': 'multipart/form-data' },
					url:"/api/homepage/uploadImages",
					data:formData,
					crossDomain:true,
					cache:false
				}).then(res => {
					this.addlicenseform.mechanicalPictures = res.data.data[0]
				  // this.emptyUpload()
				}).catch(() => {
				  this.$message.error('上传失败，请重新上传')
				  // this.emptyUpload()
				})
				
			},
			beforeAvatarUpload(file) {
			  const isJPG = file.type === 'image/jpeg'
			  const isPng = file.type === 'image/png'
			  const isLt2M = file.size / 1024 / 1024 < 2
	 
			  if (!isJPG && !isPng) {
				this.$message.error('上传图片只能是 JPG或png 格式!')
			  }
			  if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 2MB!')
			  }
			  return (isJPG || isPng) && isLt2M
			},
			handleRemove(file, fileList) {
			  for (const i in this.picList) {
				if (this.picList[i].uid === file.uid) {
				  this.picList.splice(i, 1)
				}
			  }
			},
			uploadbtn(){
				console.log(this.picList)
			},
			cancelAddlicense(formName){
				//重置表单数据
				this.$nextTick(()=>{
				  this.$refs.[formName].resetFields();
				});
				this.$router.push({name: 'showfirst', params: {licenseApplyId: this.licenseApplyId}})
			},
			saveAddlicense(formName) {
				var that = this;
				this.$refs[formName].validate((valid) => {
				  if (valid) {
					  // var mechanicalPicStr = '';
					  // if(this.picList.length>0){  lll
						 //  for(var i in this.picList){
							//   if(i == 0){
							// 	  mechanicalPicStr += this.picList[i].url;
							//   }else {
							// 	  mechanicalPicStr += ',' + this.picList[i].url;
							//   }
							
						 //  } 你好
					  // }
					  // this.addlicenseform.mechanicalPictures = mechanicalPicStr;
					  console.log('表单数据',this.addlicenseform);
					  
					this.addlicenseform.ownerIdentityCardsPhoto = this.addlicenseform.ownerIdentityCardsPhoto.toString()
					  console.log(this.addlicenseform.ownerIdentityCardsPhoto)
					  updatePcLicenseApplySh(this.addlicenseform).then(res => {
						  if(res.code == 0){
							  // 获取数据成功后的其他操作
								this.$message({
								  message: res.message,
								  type: 'success'
								});
							this.$router.push('/fzorganhistory');
								// that.$router.push({name: 'fz_seeLicenseapplysfzorgan', params: {licenseApplyId: this.licenseApplyId}})
						  }else if(res.code == 1){
							  this.$message({
							    message: res.message,
							    type: 'warning'
							  });
						  }else{
							  this.$message({
							    message: '报错啦!',
							    type: 'warning'
							  });
						  }
						   
					  });
				  } else {
					return false;
				  }
				});
			  },
			handlePictureCardPreview(file) {
			  this.dialogImageUrl = file.url
			  this.dialogVisible = true
			},
			/**
			 * 清空上传组件
			 */
			// emptyUpload() {
			//   const mainImg = this.$refs.upload
			//   if (mainImg) {
			//     if (mainImg.length) {
			//       mainImg.forEach(item => {
			//         item.clearFiles()
			//       })
			//     } else {
			//       this.$refs.upload.clearFiles()
			//     }
			//   }
			// }
        },
        computed: {
            
        }
    }

</script>

<style>
/* 上传 */
.avatar-box .el-upload.el-upload--text {
    width: 240px;
    line-height: 180px;
}
.avatar-box .el-upload.el-upload--text img {
    width: 100%;
    height: 100%;
}
.addlicense-item {
    display: flex;
    display: -webkit-flex;
}
.addlicense-item .el-form-item {
    width: 300px;
    margin-right: 50px;
}
.addlicense-item .el-date-editor.el-input,
.addlicense-item .el-date-editor.el-input__inner {
    width: 100%;
}
</style>
